module.exports = __webpack_public_path__ + "static/img/Noise_NX.dd7ef57.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/handshakes/assets/Noise_NX.png
// module id = Xx17
// module chunks = 1